import { render, staticRenderFns } from "./FoodCollection.vue?vue&type=template&id=ee3aef4e&scoped=true"
import script from "./FoodCollection.vue?vue&type=script&lang=js"
export * from "./FoodCollection.vue?vue&type=script&lang=js"
import style0 from "./FoodCollection.vue?vue&type=style&index=0&id=ee3aef4e&prod&scoped=true&lang=css"
import style1 from "./FoodCollection.vue?vue&type=style&index=1&id=ee3aef4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3aef4e",
  null
  
)

export default component.exports